import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import IconDelete from "../../../../layout/others/icon-x.svg";
import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function JobRole({ searchObject, setSearchObject, t }) {
  const [jobRolesList, setJobRolesList] = useState([]);

  useEffect(() => {
    CommonService.getAllJobRoles().then((data) => setJobRolesList(data));
  }, []);

  function setJobRoles(list) {
    setSearchObject({ ...searchObject, jobRoles: list });
  }

  function clearJobRoles() {
    let _searchObject = { ...searchObject };
    _searchObject.jobRoles = [];

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <legend className="fontsize-legend">{t("Job Role")}</legend>
      {searchObject.jobRoles?.length !== 0 && (
        <button
          onClick={clearJobRoles}
          className="btn-clear-language-level position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
        </button>
      )}
      <DropDownMultiCheck
        dataList={jobRolesList}
        selecteds={searchObject.jobRoles}
        setSelecteds={setJobRoles}
      />
    </div>
  );
}
